import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { UserFeatures, UserFeaturesStore } from './user-features.store';
import { UserFeaturesQuery } from './user-features.query';


@Injectable({
	providedIn: 'root'
})
export class UserFeaturesService {
	constructor(
		private store: UserFeaturesStore,
		private query: UserFeaturesQuery
	) { }

	update(features: UserFeatures): void {
		this.store.update(features);
	}

	getUserFeatures$(): Observable<string[]> {
		return this.query.userFeatures$.pipe(
			map((value: UserFeatures) => {
				if(value.features.length>0){
					return (value.features.toLowerCase() || '').split(',');
				}
				return [];
			})
		);
	}

	// getUserFeatures$(): Observable<string[]> {
	// 	return this.query.userFeatures$.pipe(
	// 		map((value: any[]) => {
	// 			if (typeof value === 'object' && value !== null) {
	// 				if (typeof value[0] === 'string') {
	// 					return Object.values(value);
	// 				} else if (typeof value[0] === 'object') {
	// 					return Object.values(value[0]);
	// 				}
	// 			}
	// 			return [];
	// 		})
	// 	);
	// }
}
